import { useSymbolsStore } from '../store/Symbols';
import { useSymbolsRender } from '../utils/useRender';
export var Quote = props => {
  var {
    Quote: Comp = {}
  } = useSymbolsStore();
  useSymbolsRender(Comp, props, 'Quote');
  return null;
};
Quote.displayName = 'JVR.Quote';